<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb
    [crumbs]="breadcrumbs"
    routerLink="/admin/dashboard"
  ></app-custom-breadcrumb>
  <div class="flex justify-between mt-3">
    <h2 class="my-0">My Profile</h2>
    <!-- <button nz-button nzType="primary">Add User</button> -->
  </div>
</nz-card>

<div class="main-container">
  <nz-card class="main-card">
    <div class="user-container">
      <div class="user-img mb-2">
        <nz-avatar
          [nzSize]="avatarSize"
          nzIcon="user"
          [nzSrc]="member.profilePicture?.url || ''"
        ></nz-avatar>
      </div>
      <div class="vertical-divider"></div>
      <div class="user-info">
        <div class="container">
          <h4 class="mb-0" style="color: #101010">{{ this.member.name }}</h4>
          <a nz-dropdown [nzDropdownMenu]="menuUser" nzPlacement="bottomRight">
            <span
              class="icon icon-border"
              nz-icon
              nzType="ellipsis"
              nzTheme="outline"
            ></span>
          </a>
        </div>
        <nz-dropdown-menu #menuUser="nzDropdownMenu">
          <ul nz-menu nzSelectable>
            <li
              style="width: 100px; padding-left: 10px"
              class="clickable-text"
              (click)="selectedModal = 'profile'; showModal()"
            >
              Edit
            </li>
          </ul>
        </nz-dropdown-menu>
        <p class="font-medium mb-0" style="color: #6d6d6d">
          {{ this.member.position }} | {{this.member.grade}}
        </p>
        <p class="font-normal mt-1 mb-0 text-justify" [hidden]="showFullTextPost">
          {{ this.member.description.substring(0, this.wordCap) }}
          <span class=" text-[#2F5EA4]" (click)="toggleTextPost()">{{
            showFullTextPost ? "Read Less" : "Read More"
          }}</span>
        </p>
        <p class="font-normal mt-1 mb-0 text-justify" [hidden]="!showFullTextPost">
          {{ this.member.description }}
          <span class=" text-[#2F5EA4]" (click)="toggleTextPost()">{{
            showFullTextPost ? "Read Less" : "Read More"
          }}</span>
        </p>
      </div>
    </div>
    <div class="divider-container">
      <nz-divider></nz-divider>
    </div>
    <div class="content-container">
      <nz-tabset [nzCentered]="true">
        <nz-tab nzTitle="Feed">
          <div style="display: flex; justify-content: center">
            <nz-card nzSize="small" class="add-post">
              <button
                nz-button
                class="add-post-btn font-medium"
                (click)="this.selectedModal = 'post'; showModal()"
              >
                Add New Post
              </button>
            </nz-card>
          </div>

          <div class="post-container mt-3">
            <h4 *ngIf="this.feed.length < 1">No Feed</h4>
            <nz-card
              class="mt-5 post-card p-1"
              *ngFor="let post of this.feed; let i = index"
            >
              <div class="container">
                <h3 class="font-semibold">{{ post.title }}</h3>
                <div class="icon-container">
                  <a
                    nz-dropdown
                    [nzDropdownMenu]="menuPost"
                    nzPlacement="bottomRight"
                  >
                    <span
                      class="icon icon-border"
                      nz-icon
                      nzType="ellipsis"
                      nzTheme="outline"
                    ></span>
                  </a>
                </div>
              </div>

              <nz-dropdown-menu #menuPost="nzDropdownMenu">
                <ul nz-menu nzSelectable>
                  <li
                    style="width: 100px; padding-left: 10px"
                    class="clickable-text"
                    (click)="
                      editSetup(this.post);
                      selectedModal = 'editPost';
                      showModal()
                    "
                  >
                    Edit
                  </li>
                  <li
                    style="width: 100px; padding-left: 10px"
                    class="clickable-text "
                  >
                    <a
                      nz-popconfirm
                      nzPopconfirmTitle="Are you sure delete this post?"
                      nzPopconfirmPlacement="bottom"
                      (nzOnConfirm)="confirm(this.post.id)"
                      (nzOnCancel)="cancel()"
                      class="text-red-400"
                    >
                      Delete
                    </a>
                  </li>
                </ul>
              </nz-dropdown-menu>

              <p class="font-normal" [hidden]="isExpanded[i]">
                {{ post.content.substring(0, this.wordCap) }}
                <span *ngIf="post.content.length > this.wordCap">...</span>
                <span
                  class="text-[#2F5EA4]"
                  *ngIf="post.content.length > this.wordCap"
                  (click)="toggleExpansion(i)"
                  >{{ isExpanded[i] ? "Read Less" : "Read More" }}</span
                >
              </p>
              <p class="font-normal" [hidden]="!isExpanded[i]">
                {{ this.post.content
                }}<span class="text-[#2F5EA4]" (click)="toggleExpansion(i)">{{
                  isExpanded[i] ? "Read Less" : "Read More"
                }}</span>
              </p>

              <div
                class="media-container w-full h-auto object-cover mt-5"
                *ngIf="this.post.media && this.post.media.url !== ''"
              >
                <video
                  width="100%"
                  height="360"
                  controls
                  *ngIf="this.post.media.mimeType?.startsWith('video/mp4')"
                >
                  <source [src]="this.post.media.url" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <img
                  [src]="this.post.media.url"
                  style="width: 100%"
                  *ngIf="this.post.media.mimeType?.startsWith('image/')"
                  (error)="onImageError($event)"
                  alt="Image Unavailable"
                />

                <div
                  class="mb-2 clickable-text bg-[#F0F2F5] w-full px-3 py-4 flex justify-start gap-3 items-center rounded-md"
                  *ngIf="this.post.media?.mimeType === 'application/pdf'"
                >
                  <img src="assets/img/signle-event/pdf.png" alt="'pdf" />
                  <a [href]="this.post.media.url" target="_blank"
                    ><h6>{{ this.post.media.filename }}</h6></a
                  >
                </div>
              </div>
              <div>
                <p class="font-medium text-sm mt-4" style="color: #6d6d6d">
                  {{ this.formatDate(this.post.createdAt) }}
                </p>
              </div>
            </nz-card>
          </div>

          <nz-modal
            [(nzVisible)]="isVisible"
            [nzTitle]="modalTitle"
            [nzContent]="modalContent"
            [nzFooter]="null"
            nzClosable="false"
          >
            <ng-template #modalTitle>
              <div class="flex" style="align-items: center">
                <span class="header-trigger" (click)="handleCancel()">
                  <span nz-icon nzType="close" nzTheme="outline"></span>
                </span>
                <div class="px-3 flex-grow">
                  <p
                    *ngIf="selectedModal === 'post'"
                    style="margin-bottom: 0"
                    class="font-semibold text-normal"
                  >
                    Add New Post
                  </p>
                  <p
                    *ngIf="selectedModal === 'editPost'"
                    style="margin-bottom: 0"
                    class="font-semibold text-normal"
                  >
                    Edit Post
                  </p>
                  <p
                    *ngIf="selectedModal === 'profile'"
                    style="margin-bottom: 0"
                    class="font-semibold text-normal"
                  >
                    Edit My Profile
                  </p>
                </div>
                <button
                  *ngIf="selectedModal === 'post'"
                  nz-button
                  nzType="primary"
                  class="font-normal"
                  (click)="submitForm()"
                  [disabled]="this.postForm.invalid"
                >
                  Publish Post
                </button>
                <button
                  *ngIf="selectedModal === 'editPost'"
                  nz-button
                  nzType="primary"
                  class="font-normal"
                  (click)="editPostSubmit()"
                >
                  Update Post
                </button>
                <button
                  *ngIf="selectedModal === 'profile'"
                  nz-button
                  nzType="primary"
                  class="font-normal"
                  (click)="editProfile()"
                  [disabled]="this.memberForm.invalid"
                >
                  Save Changes
                </button>
              </div>
            </ng-template>

            <ng-template #modalContent>
              <form
                nz-form
                [formGroup]="postForm"
                *ngIf="selectedModal === 'post'"
                class="login-form"
              >
                <nz-form-item class="mb-3">
                  <nz-form-control nzErrorTip="Title is required">
                    <nz-input-group>
                      <input
                        type="text"
                        nz-input
                        formControlName="title"
                        placeholder="Title"
                      />
                    </nz-input-group>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="mb-3">
                  <nz-form-control>
                    <nz-input-group>
                      <textarea
                        type="text"
                        nz-input
                        formControlName="content"
                        placeholder="Type content here"
                        [nzAutosize]="{ minRows: 5, maxRows: 8 }"
                      ></textarea>
                    </nz-input-group>
                  </nz-form-control>
                </nz-form-item>

                <div style="padding: 30px; background-color: #f5f5f5">
                  <ngx-dropzone
                    [multiple]="false"
                    class="mt-1 mb-1"
                    (change)="onSelect($event)"
                  >
                    <ngx-dropzone-label>
                      <h5 class="font-normal text-base">
                        Click or drag file to this area to upload
                      </h5>
                      <p>||||||||||||||||||||||||||||||||||||||||</p>
                    </ngx-dropzone-label>
                    <ngx-dropzone-preview
                      *ngFor="let f of files"
                      [removable]="true"
                      (removed)="onRemove(f)"
                    >
                      <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                  </ngx-dropzone>
                </div>
              </form>

              <form
                nz-form
                [formGroup]="editPostForm"
                *ngIf="selectedModal === 'editPost'"
                class="login-form"
              >
                <nz-form-item class="mb-3">
                  <nz-form-control nzErrorTip="Title is required">
                    <nz-input-group>
                      <input
                        type="text"
                        nz-input
                        formControlName="title"
                        placeholder="Title"
                      />
                    </nz-input-group>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="mb-3">
                  <nz-form-control>
                    <nz-input-group>
                      <textarea
                        type="text"
                        nz-input
                        formControlName="content"
                        placeholder="Type content here"
                        [nzAutosize]="{ minRows: 5, maxRows: 8 }"
                      ></textarea>
                    </nz-input-group>
                  </nz-form-control>
                </nz-form-item>

                <p>Add New Media</p>
                <div style="padding: 30px; background-color: #f5f5f5">
                  <ngx-dropzone
                    [multiple]="false"
                    class="mt-1 mb-1"
                    (change)="onSelect($event)"
                  >
                    <ngx-dropzone-label>
                      <h5 class="font-normal text-base">
                        Click or drag file to this area to upload
                      </h5>
                      <p>||||||||||||||||||||||||||||||||||||||||</p>
                    </ngx-dropzone-label>
                    <ngx-dropzone-preview
                      *ngFor="let f of files"
                      [removable]="true"
                      (removed)="onRemove(f)"
                    >
                      <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                  </ngx-dropzone>
                </div>
              </form>

              <form
                nz-form
                [formGroup]="memberForm"
                *ngIf="selectedModal === 'profile'"
                class="login-form mx-8"
              >
                <div class="row-container">
                  <div class="row-contents">
                    <nz-avatar
                      [nzSize]="100"
                      nzIcon="user"
                      [nzSrc]="member.profilePicture?.url || ''"
                    ></nz-avatar>

                    <a
                      nz-popconfirm
                      nzPopconfirmTitle="Remove Profile Picture ?"
                      nzPopconfirmPlacement="bottom"
                      (nzOnConfirm)="removeProfileImage()"
                      (nzOnCancel)="cancel()"
                    >
                      <img
                        src="assets/img/normal.png"
                        alt="badge"
                        class="badge-img clickable-text"
                      />
                    </a>
                  </div>
                  <button nz-button class="mx-10" (click)="showModal2()">
                    Upload Image
                  </button>
                </div>

                <nz-divider style="width: 100%"></nz-divider>

                <h4 class="mb-2">Contact Details</h4>
                <div class="flex lg:flex-row flex-col gap-4">
                  <div class="lg:w-1/2 w-full">
                    <p class="font-normal" style="margin-bottom: 0">
                      Mobile Number
                    </p>
                    <nz-form-item class="mb-3">
                      <nz-form-control nzErrorTip="Mobile number is required">
                        <nz-input-group>
                          <input
                            type="text"
                            nz-input
                            formControlName="mobileNo"
                            placeholder="Enter Valid Mobile number"
                          />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div class="lg:w-1/2 w-full">
                    <p class="font-normal" style="margin-bottom: 0">
                      Phone Number
                    </p>
                    <nz-form-item class="mb-3">
                      <nz-form-control nzErrorTip="Enter Valid Phone number">
                        <nz-input-group>
                          <input
                            type="text"
                            nz-input
                            formControlName="phoneNo"
                            placeholder="Enter Phone number"
                          />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>

                <nz-divider style="width: 100% ; margin: 15px 0;"></nz-divider>

                <h4 class="mb-2">About</h4>
                <div class="flex lg:flex-row flex-col gap-4">
                  <div class="lg:w-1/2 w-full">
                    <p class="font-normal" style="margin-bottom: 0">
                      Workplace
                    </p>
                    <nz-form-item class="mb-3">
                      <nz-form-control nzErrorTip="Workplace is required">
                        <nz-input-group>
                          <input
                            type="text"
                            nz-input
                            formControlName="workplace"
                            placeholder="Enter Workplace"
                          />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div class="lg:w-1/2 w-full">
                    <p class="font-normal" style="margin-bottom: 0">
                      Residence
                    </p>
                    <nz-form-item class="mb-3">
                      <nz-form-control nzErrorTip="Residence is required">
                        <nz-input-group>
                          <input
                            type="text"
                            nz-input
                            formControlName="residence"
                            placeholder="Enter Residence"
                          />
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>

                <p class="font-normal mt-2" style="margin-bottom: 0">Bio</p>
                <nz-form-item class="mb-3">
                  <nz-form-control nzErrorTip="Bio is required">
                    <nz-input-group>
                      <textarea
                        type="text"
                        nz-input
                        formControlName="description"
                        placeholder="Enter a brief description about yourself"
                        [nzAutosize]="{ minRows: 5, maxRows: 8 }"
                      ></textarea>
                    </nz-input-group>
                  </nz-form-control>
                </nz-form-item>
              </form>
            </ng-template>
          </nz-modal>

          <nz-modal
            [(nzVisible)]="inVisibleModal2"
            [nzFooter]="modalFooter2"
            nzClosable="false"
            nzTitle="Upload Image"
          >
            <ng-container *nzModalContent>
              <div style="padding: 30px; background-color: #f5f5f5">
                <ngx-dropzone
                  [multiple]="false"
                  accept="image/jpeg,image/jpg,image/png,image/gif"
                  class="mt-1 mb-1"
                  (change)="onSelect($event)"
                >
                  <ngx-dropzone-label>
                    <h5 class="font-normal text-base">
                      Click or drag file to this area to upload
                    </h5>
                  </ngx-dropzone-label>
                  <ngx-dropzone-preview
                    *ngFor="let f of files"
                    [removable]="true"
                    (removed)="onRemove(f)"
                  >
                    <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                  </ngx-dropzone-preview>
                </ngx-dropzone>
              </div>
            </ng-container>

            <ng-template #modalFooter2>
              <button nz-button nzType="default" (click)="handleCancel2()">
                Cancel
              </button>
              <button nz-button nzType="primary" (click)="handleOkModal2()">
                Update
              </button>
            </ng-template>
          </nz-modal>

          <nz-divider></nz-divider>
        </nz-tab>

        <nz-tab nzTitle="Contact Details">
          <table>
            <tr>
              <td><span class="sub-text font-semibold">Email: </span></td>
              <td><p class="font-medium  mb-0 clickable-text" style="margin-left:15px">
                {{ this.member.email }}
              </p></td>
            </tr>
            <tr>
              <td><span class="sub-text font-semibold">Mobile Number: </span></td>
              <td><p class="font-medium mb-0 clickable-text" style="margin-left:15px">
                {{ this.member.mobileNo }}
              </p></td>
            </tr>
            <tr>
              <td><span class="sub-text font-semibold">Phone Number: </span></td>
              <td><p class="font-medium mb-0 clickable-text" style="margin-left:15px">
                {{ this.member.phoneNo }}
              </p></td>
            </tr>
          </table>
        </nz-tab>

        <nz-tab nzTitle="About">
          <p class="font-medium mt-5 mb-4">{{ this.member.description }}</p>
          <p class="font-medium mb-3">
            <span class="sub-text font-semibold">Workplace: </span
            >{{ this.member.workplace }}
          </p>
          <p class="font-medium mb-3">
            <span class="sub-text font-semibold">Residence: </span>
            {{ this.member.residence }}
          </p>
        </nz-tab>

        <nz-tab nzTitle="Events">
          <div>
            <div class="max-w-[650px] w-[100%] mx-auto">
              <nz-tabset class="mb-5">
                <nz-tab nzTitle="Registered">
                  <div *ngFor="let event of acceptedEvents">
                    <div
                      class="flex border-[1px] border-solid border-[#F0F0F0] rounded-lg p-5 justify-between xl:items-center gap-5 relative flex-col xl:flex-row"
                      *ngIf="event.eventType === 'Registration'" style="margin-bottom: 1rem"
                    >
                      <p
                        class="top-7 left-7 absolute font-[500] text-[13px] !text-[#fff] bg-[#28C5C0] rounded-full px-2 z-10"
                      >
                        {{ event.eventType }}
                      </p>
                      <div class="basis-[40%] h-[150px] xl:h-[300px] w-full">
                        <img
                          class="w-full rounded-lg h-full object-cover"
                          alt="image"
                          (error)="onImageError($event)"
                          [src]="event.thumbnail?.url || ''"
                        />
                      </div>
                      <div class="basis-[60%] w-full">
                        <h4
                          class="text-[#2F5EA4]  xsm:!text-md clickable-text"
                          (click)="viewEvent(this.event.id)"
                        >
                          {{ event.name }}
                        </h4>
                        <div class="my-3">
                          <p class="flex justify-start gap-2 items-center mb-0">
                            <svg
                              width="12"
                              height="15"
                              viewBox="0 0 12 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.738 12.1832L7.16878 11.6949L7.738 12.1832ZM4.262 12.1832L3.69279 12.6716L4.262 12.1832ZM6 13.5V12.75V13.5ZM10.25 6.41797C10.25 7.01125 9.89933 7.87637 9.27258 8.88918C8.66644 9.8687 7.87869 10.8674 7.16878 11.6949L8.30721 12.6716C9.0409 11.8164 9.88415 10.7514 10.5481 9.6785C11.1915 8.63885 11.75 7.46268 11.75 6.41797H10.25ZM4.83122 11.6949C4.12131 10.8674 3.33356 9.8687 2.72742 8.88918C2.10067 7.87637 1.75 7.01125 1.75 6.41797H0.25C0.25 7.46268 0.808534 8.63885 1.45189 9.6785C2.11585 10.7514 2.9591 11.8164 3.69279 12.6716L4.83122 11.6949ZM1.75 6.41797C1.75 4.12771 3.64105 2.25 6 2.25V0.75C2.83611 0.75 0.25 3.27599 0.25 6.41797H1.75ZM6 2.25C8.35895 2.25 10.25 4.12771 10.25 6.41797H11.75C11.75 3.27599 9.16389 0.75 6 0.75V2.25ZM7.16878 11.6949C6.77522 12.1536 6.53959 12.4244 6.33556 12.5938C6.16603 12.7345 6.08353 12.75 6 12.75V14.25C6.52474 14.25 6.93467 14.046 7.29377 13.7478C7.61838 13.4783 7.94762 13.0907 8.30721 12.6716L7.16878 11.6949ZM3.69279 12.6716C4.05238 13.0907 4.38161 13.4783 4.70623 13.7478C5.06533 14.046 5.47526 14.25 6 14.25V12.75C5.91647 12.75 5.83397 12.7345 5.66444 12.5938C5.46041 12.4244 5.22478 12.1536 4.83122 11.6949L3.69279 12.6716ZM3.375 6.64152C3.375 8.06428 4.61512 9.10536 6 9.10536V7.60536C5.31381 7.60536 4.875 7.11181 4.875 6.64152H3.375ZM6 9.10536C7.38488 9.10536 8.625 8.06428 8.625 6.64152H7.125C7.125 7.11181 6.68619 7.60536 6 7.60536V9.10536ZM8.625 6.64152C8.625 5.21876 7.38488 4.17768 6 4.17768V5.67768C6.68619 5.67768 7.125 6.17122 7.125 6.64152H8.625ZM6 4.17768C4.61512 4.17768 3.375 5.21876 3.375 6.64152H4.875C4.875 6.17122 5.31381 5.67768 6 5.67768V4.17768Z"
                                fill="#2D264B"
                                fill-opacity="0.25"
                              />
                            </svg>
                            <span class="font-semibold text-[13px]">{{
                              event.venue
                            }}</span>
                          </p>
                          <p class="flex justify-start gap-2 items-center">
                            <svg
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.25955 12.9271L2.69509 12.3165L2.25955 12.9271ZM1.58356 12.2634L2.18644 11.8172L1.58356 12.2634ZM11.4164 12.2634L10.8136 11.8172L11.4164 12.2634ZM10.7405 12.9271L11.176 13.5376L10.7405 12.9271ZM10.7405 3.27295L11.176 2.66237L10.7405 3.27295ZM11.4164 3.93664L10.8136 4.38278L11.4164 3.93664ZM2.25955 3.27295L2.69509 3.88352L2.69509 3.88352L2.25955 3.27295ZM1.58356 3.93664L2.18644 4.38278V4.38278L1.58356 3.93664ZM10.9109 9.93694L10.7957 9.19584L10.9109 9.93694ZM8.37095 12.4307L7.63052 12.3113L8.37095 12.4307ZM4.66667 7.95C4.25245 7.95 3.91667 8.28579 3.91667 8.7C3.91667 9.11421 4.25245 9.45 4.66667 9.45V7.95ZM8.33333 9.45C8.74755 9.45 9.08333 9.11421 9.08333 8.7C9.08333 8.28579 8.74755 7.95 8.33333 7.95V9.45ZM7.58333 3.3C7.58333 3.71421 7.91912 4.05 8.33333 4.05C8.74755 4.05 9.08333 3.71421 9.08333 3.3H7.58333ZM9.08333 1.5C9.08333 1.08579 8.74755 0.75 8.33333 0.75C7.91912 0.75 7.58333 1.08579 7.58333 1.5H9.08333ZM3.91667 3.3C3.91667 3.71421 4.25245 4.05 4.66667 4.05C5.08088 4.05 5.41667 3.71421 5.41667 3.3H3.91667ZM5.41667 1.5C5.41667 1.08579 5.08088 0.75 4.66667 0.75C4.25245 0.75 3.91667 1.08579 3.91667 1.5H5.41667ZM11.9823 9.9L12.7319 9.92616L11.9823 9.9ZM1.01768 6.3L0.268135 6.27384L1.01768 6.3ZM11.9823 6.3L12.7319 6.27384L11.9823 6.3ZM6.5 12.75C5.33784 12.75 4.52538 12.749 3.90099 12.6826C3.28984 12.6176 2.94812 12.497 2.69509 12.3165L1.824 13.5376C2.37417 13.9301 3.00692 14.0959 3.74233 14.1742C4.46449 14.251 5.37066 14.25 6.5 14.25V12.75ZM0.25 8.1C0.25 9.20791 0.248933 10.1002 0.32747 10.8119C0.407648 11.5385 0.578122 12.1655 0.980677 12.7095L2.18644 11.8172C2.00544 11.5726 1.88413 11.2429 1.81842 10.6474C1.75107 10.037 1.75 9.24193 1.75 8.1H0.25ZM2.69509 12.3165C2.49938 12.1769 2.32783 12.0083 2.18644 11.8172L0.980677 12.7095C1.21622 13.0278 1.50091 13.3072 1.824 13.5376L2.69509 12.3165ZM10.8136 11.8172C10.6722 12.0083 10.5006 12.1769 10.3049 12.3165L11.176 13.5376C11.4991 13.3072 11.7838 13.0278 12.0193 12.7095L10.8136 11.8172ZM10.3049 3.88352C10.5006 4.02313 10.6722 4.19171 10.8136 4.38278L12.0193 3.49051C11.7838 3.17221 11.4991 2.89284 11.176 2.66237L10.3049 3.88352ZM1.824 2.66237C1.50091 2.89285 1.21622 3.17221 0.980677 3.49051L2.18644 4.38278C2.32783 4.19171 2.49938 4.02313 2.69509 3.88352L1.824 2.66237ZM10.7957 9.19584C9.17493 9.44787 7.89059 10.6991 7.63052 12.3113L9.11138 12.5501C9.26547 11.5949 10.032 10.8326 11.0261 10.678L10.7957 9.19584ZM4.66667 9.45H8.33333V7.95H4.66667V9.45ZM11.9823 9.15C11.4534 9.15 11.1022 9.14818 10.7957 9.19584L11.0261 10.678C11.1897 10.6526 11.3994 10.65 11.9823 10.65L11.9823 9.15ZM11.25 8.1C11.25 8.80558 11.2499 9.3831 11.2328 9.87384L12.7319 9.92616C12.7501 9.40368 12.75 8.79713 12.75 8.1H11.25ZM11.2328 9.87384C11.1941 10.982 11.067 11.4747 10.8136 11.8172L12.0193 12.7095C12.5691 11.9665 12.6925 11.055 12.7319 9.92616L11.2328 9.87384ZM9.08333 13.4826C9.08334 12.9088 9.0861 12.7069 9.11138 12.5501L7.63052 12.3113C7.58136 12.6161 7.58334 12.9648 7.58333 13.4826L9.08333 13.4826ZM6.5 14.25C7.21027 14.25 7.82726 14.2501 8.35855 14.2322L8.30812 12.7331C7.80743 12.7499 7.21842 12.75 6.5 12.75V14.25ZM8.35855 14.2322C9.50599 14.1936 10.4253 14.0731 11.176 13.5376L10.3049 12.3165C9.94993 12.5697 9.43912 12.695 8.30812 12.7331L8.35855 14.2322ZM1.75 8.1C1.75 7.39442 1.7501 6.8169 1.76722 6.32616L0.268135 6.27384C0.249903 6.79632 0.25 7.40287 0.25 8.1H1.75ZM1.76722 6.32616C1.80589 5.218 1.93296 4.72532 2.18644 4.38278L0.980677 3.49051C0.430874 4.23349 0.307527 5.14498 0.268135 6.27384L1.76722 6.32616ZM1.01768 7.05H11.9823V5.55H1.01768V7.05ZM12.75 8.1C12.75 7.40287 12.7501 6.79632 12.7319 6.27384L11.2328 6.32616C11.2499 6.8169 11.25 7.39442 11.25 8.1H12.75ZM12.7319 6.27384C12.6925 5.14498 12.5691 4.23349 12.0193 3.49051L10.8136 4.38278C11.067 4.72532 11.1941 5.218 11.2328 6.32616L12.7319 6.27384ZM9.08333 3.3V2.71736H7.58333V3.3H9.08333ZM9.08333 2.71736V1.5H7.58333V2.71736H9.08333ZM6.5 3.45C7.21842 3.45 7.80743 3.45009 8.30812 3.46693L8.35855 1.96778C7.82726 1.94991 7.21027 1.95 6.5 1.95V3.45ZM8.30812 3.46693C9.43912 3.50498 9.94993 3.63031 10.3049 3.88352L11.176 2.66237C10.4253 2.12691 9.50599 2.00638 8.35855 1.96778L8.30812 3.46693ZM5.41667 3.3V2.71736H3.91667V3.3H5.41667ZM5.41667 2.71736V1.5H3.91667V2.71736H5.41667ZM6.5 1.95C5.78973 1.95 5.17274 1.94991 4.64145 1.96778L4.69188 3.46693C5.19257 3.45009 5.78158 3.45 6.5 3.45V1.95ZM4.64145 1.96778C3.49401 2.00638 2.57465 2.12691 1.824 2.66237L2.69509 3.88352C3.05007 3.63031 3.56088 3.50498 4.69188 3.46693L4.64145 1.96778Z"
                                fill="#2D264B"
                                fill-opacity="0.25"
                              />
                            </svg>
                            <span class="font-semibold text-[13px]">{{
                              this.formatDate(event.startTime)
                            }}</span>
                          </p>
                        </div>
                        <p
                          class="mt-3 text-[#706D6D] font-[400]"
                          *ngIf="
                            event.description && event.description.length > 250
                          "
                        >
                          {{ event.description.substring(0, 250) }} ...
                        </p>
                        <p
                          class="mt-3 text-[#706D6D] font-[400]"
                          *ngIf="
                            event.description && event.description.length < 250
                          "
                        >
                          {{ event.description }}
                        </p>
                      </div>
                    </div>
                  </div>
                </nz-tab>
                <nz-tab nzTitle="Accepted">
                  <div *ngFor="let event of acceptedEvents">
                    <div
                      class="flex border-[1px] border-solid border-[#F0F0F0] rounded-lg p-5 justify-between xl:items-center gap-5 relative flex-col xl:flex-row"
                      *ngIf="event.eventType === 'Invite Only'" style="margin-bottom: 1rem"
                    >
                      <p
                        class="top-7 left-7 absolute font-[500] text-[13px] !text-[#fff] bg-[#28C5C0] rounded-full px-2 z-10"
                      >
                        {{ event.eventType }}
                      </p>
                      <div class="basis-[40%] h-[150px] xl:h-[300px] w-full">
                        <img
                          class="w-full rounded-lg h-full object-cover"
                          alt="image"
                          (error)="onImageError($event)"
                          [src]="event.thumbnail?.url || ''"
                        />
                      </div>
                      <div class="basis-[60%] w-full">
                        <h4
                          class="text-[#2F5EA4]  xsm:!text-md clickable-text"
                          (click)="viewEvent(this.event.id)"
                        >
                          {{ event.name }}
                        </h4>
                        <div class="my-3">
                          <p class="flex justify-start gap-2 items-center mb-0">
                            <svg
                              width="12"
                              height="15"
                              viewBox="0 0 12 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.738 12.1832L7.16878 11.6949L7.738 12.1832ZM4.262 12.1832L3.69279 12.6716L4.262 12.1832ZM6 13.5V12.75V13.5ZM10.25 6.41797C10.25 7.01125 9.89933 7.87637 9.27258 8.88918C8.66644 9.8687 7.87869 10.8674 7.16878 11.6949L8.30721 12.6716C9.0409 11.8164 9.88415 10.7514 10.5481 9.6785C11.1915 8.63885 11.75 7.46268 11.75 6.41797H10.25ZM4.83122 11.6949C4.12131 10.8674 3.33356 9.8687 2.72742 8.88918C2.10067 7.87637 1.75 7.01125 1.75 6.41797H0.25C0.25 7.46268 0.808534 8.63885 1.45189 9.6785C2.11585 10.7514 2.9591 11.8164 3.69279 12.6716L4.83122 11.6949ZM1.75 6.41797C1.75 4.12771 3.64105 2.25 6 2.25V0.75C2.83611 0.75 0.25 3.27599 0.25 6.41797H1.75ZM6 2.25C8.35895 2.25 10.25 4.12771 10.25 6.41797H11.75C11.75 3.27599 9.16389 0.75 6 0.75V2.25ZM7.16878 11.6949C6.77522 12.1536 6.53959 12.4244 6.33556 12.5938C6.16603 12.7345 6.08353 12.75 6 12.75V14.25C6.52474 14.25 6.93467 14.046 7.29377 13.7478C7.61838 13.4783 7.94762 13.0907 8.30721 12.6716L7.16878 11.6949ZM3.69279 12.6716C4.05238 13.0907 4.38161 13.4783 4.70623 13.7478C5.06533 14.046 5.47526 14.25 6 14.25V12.75C5.91647 12.75 5.83397 12.7345 5.66444 12.5938C5.46041 12.4244 5.22478 12.1536 4.83122 11.6949L3.69279 12.6716ZM3.375 6.64152C3.375 8.06428 4.61512 9.10536 6 9.10536V7.60536C5.31381 7.60536 4.875 7.11181 4.875 6.64152H3.375ZM6 9.10536C7.38488 9.10536 8.625 8.06428 8.625 6.64152H7.125C7.125 7.11181 6.68619 7.60536 6 7.60536V9.10536ZM8.625 6.64152C8.625 5.21876 7.38488 4.17768 6 4.17768V5.67768C6.68619 5.67768 7.125 6.17122 7.125 6.64152H8.625ZM6 4.17768C4.61512 4.17768 3.375 5.21876 3.375 6.64152H4.875C4.875 6.17122 5.31381 5.67768 6 5.67768V4.17768Z"
                                fill="#2D264B"
                                fill-opacity="0.25"
                              />
                            </svg>
                            <span class="font-semibold text-[13px]">{{
                              event.venue
                            }}</span>
                          </p>
                          <p class="flex justify-start gap-2 items-center">
                            <svg
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.25955 12.9271L2.69509 12.3165L2.25955 12.9271ZM1.58356 12.2634L2.18644 11.8172L1.58356 12.2634ZM11.4164 12.2634L10.8136 11.8172L11.4164 12.2634ZM10.7405 12.9271L11.176 13.5376L10.7405 12.9271ZM10.7405 3.27295L11.176 2.66237L10.7405 3.27295ZM11.4164 3.93664L10.8136 4.38278L11.4164 3.93664ZM2.25955 3.27295L2.69509 3.88352L2.69509 3.88352L2.25955 3.27295ZM1.58356 3.93664L2.18644 4.38278V4.38278L1.58356 3.93664ZM10.9109 9.93694L10.7957 9.19584L10.9109 9.93694ZM8.37095 12.4307L7.63052 12.3113L8.37095 12.4307ZM4.66667 7.95C4.25245 7.95 3.91667 8.28579 3.91667 8.7C3.91667 9.11421 4.25245 9.45 4.66667 9.45V7.95ZM8.33333 9.45C8.74755 9.45 9.08333 9.11421 9.08333 8.7C9.08333 8.28579 8.74755 7.95 8.33333 7.95V9.45ZM7.58333 3.3C7.58333 3.71421 7.91912 4.05 8.33333 4.05C8.74755 4.05 9.08333 3.71421 9.08333 3.3H7.58333ZM9.08333 1.5C9.08333 1.08579 8.74755 0.75 8.33333 0.75C7.91912 0.75 7.58333 1.08579 7.58333 1.5H9.08333ZM3.91667 3.3C3.91667 3.71421 4.25245 4.05 4.66667 4.05C5.08088 4.05 5.41667 3.71421 5.41667 3.3H3.91667ZM5.41667 1.5C5.41667 1.08579 5.08088 0.75 4.66667 0.75C4.25245 0.75 3.91667 1.08579 3.91667 1.5H5.41667ZM11.9823 9.9L12.7319 9.92616L11.9823 9.9ZM1.01768 6.3L0.268135 6.27384L1.01768 6.3ZM11.9823 6.3L12.7319 6.27384L11.9823 6.3ZM6.5 12.75C5.33784 12.75 4.52538 12.749 3.90099 12.6826C3.28984 12.6176 2.94812 12.497 2.69509 12.3165L1.824 13.5376C2.37417 13.9301 3.00692 14.0959 3.74233 14.1742C4.46449 14.251 5.37066 14.25 6.5 14.25V12.75ZM0.25 8.1C0.25 9.20791 0.248933 10.1002 0.32747 10.8119C0.407648 11.5385 0.578122 12.1655 0.980677 12.7095L2.18644 11.8172C2.00544 11.5726 1.88413 11.2429 1.81842 10.6474C1.75107 10.037 1.75 9.24193 1.75 8.1H0.25ZM2.69509 12.3165C2.49938 12.1769 2.32783 12.0083 2.18644 11.8172L0.980677 12.7095C1.21622 13.0278 1.50091 13.3072 1.824 13.5376L2.69509 12.3165ZM10.8136 11.8172C10.6722 12.0083 10.5006 12.1769 10.3049 12.3165L11.176 13.5376C11.4991 13.3072 11.7838 13.0278 12.0193 12.7095L10.8136 11.8172ZM10.3049 3.88352C10.5006 4.02313 10.6722 4.19171 10.8136 4.38278L12.0193 3.49051C11.7838 3.17221 11.4991 2.89284 11.176 2.66237L10.3049 3.88352ZM1.824 2.66237C1.50091 2.89285 1.21622 3.17221 0.980677 3.49051L2.18644 4.38278C2.32783 4.19171 2.49938 4.02313 2.69509 3.88352L1.824 2.66237ZM10.7957 9.19584C9.17493 9.44787 7.89059 10.6991 7.63052 12.3113L9.11138 12.5501C9.26547 11.5949 10.032 10.8326 11.0261 10.678L10.7957 9.19584ZM4.66667 9.45H8.33333V7.95H4.66667V9.45ZM11.9823 9.15C11.4534 9.15 11.1022 9.14818 10.7957 9.19584L11.0261 10.678C11.1897 10.6526 11.3994 10.65 11.9823 10.65L11.9823 9.15ZM11.25 8.1C11.25 8.80558 11.2499 9.3831 11.2328 9.87384L12.7319 9.92616C12.7501 9.40368 12.75 8.79713 12.75 8.1H11.25ZM11.2328 9.87384C11.1941 10.982 11.067 11.4747 10.8136 11.8172L12.0193 12.7095C12.5691 11.9665 12.6925 11.055 12.7319 9.92616L11.2328 9.87384ZM9.08333 13.4826C9.08334 12.9088 9.0861 12.7069 9.11138 12.5501L7.63052 12.3113C7.58136 12.6161 7.58334 12.9648 7.58333 13.4826L9.08333 13.4826ZM6.5 14.25C7.21027 14.25 7.82726 14.2501 8.35855 14.2322L8.30812 12.7331C7.80743 12.7499 7.21842 12.75 6.5 12.75V14.25ZM8.35855 14.2322C9.50599 14.1936 10.4253 14.0731 11.176 13.5376L10.3049 12.3165C9.94993 12.5697 9.43912 12.695 8.30812 12.7331L8.35855 14.2322ZM1.75 8.1C1.75 7.39442 1.7501 6.8169 1.76722 6.32616L0.268135 6.27384C0.249903 6.79632 0.25 7.40287 0.25 8.1H1.75ZM1.76722 6.32616C1.80589 5.218 1.93296 4.72532 2.18644 4.38278L0.980677 3.49051C0.430874 4.23349 0.307527 5.14498 0.268135 6.27384L1.76722 6.32616ZM1.01768 7.05H11.9823V5.55H1.01768V7.05ZM12.75 8.1C12.75 7.40287 12.7501 6.79632 12.7319 6.27384L11.2328 6.32616C11.2499 6.8169 11.25 7.39442 11.25 8.1H12.75ZM12.7319 6.27384C12.6925 5.14498 12.5691 4.23349 12.0193 3.49051L10.8136 4.38278C11.067 4.72532 11.1941 5.218 11.2328 6.32616L12.7319 6.27384ZM9.08333 3.3V2.71736H7.58333V3.3H9.08333ZM9.08333 2.71736V1.5H7.58333V2.71736H9.08333ZM6.5 3.45C7.21842 3.45 7.80743 3.45009 8.30812 3.46693L8.35855 1.96778C7.82726 1.94991 7.21027 1.95 6.5 1.95V3.45ZM8.30812 3.46693C9.43912 3.50498 9.94993 3.63031 10.3049 3.88352L11.176 2.66237C10.4253 2.12691 9.50599 2.00638 8.35855 1.96778L8.30812 3.46693ZM5.41667 3.3V2.71736H3.91667V3.3H5.41667ZM5.41667 2.71736V1.5H3.91667V2.71736H5.41667ZM6.5 1.95C5.78973 1.95 5.17274 1.94991 4.64145 1.96778L4.69188 3.46693C5.19257 3.45009 5.78158 3.45 6.5 3.45V1.95ZM4.64145 1.96778C3.49401 2.00638 2.57465 2.12691 1.824 2.66237L2.69509 3.88352C3.05007 3.63031 3.56088 3.50498 4.69188 3.46693L4.64145 1.96778Z"
                                fill="#2D264B"
                                fill-opacity="0.25"
                              />
                            </svg>
                            <span class="font-semibold text-[13px]">{{
                              this.formatDate(event.startTime)
                            }}</span>
                          </p>
                        </div>
                        <p
                          class="mt-3 text-[#706D6D] font-[400]"
                          *ngIf="
                            event.description && event.description.length > 250
                          "
                        >
                          {{ event.description.substring(0, 250) }} ...
                        </p>
                        <p
                          class="mt-3 text-[#706D6D] font-[400]"
                          *ngIf="
                            event.description && event.description.length < 250
                          "
                        >
                          {{ event.description }}
                        </p>
                      </div>
                    </div>

                  </div>
                </nz-tab>
                <nz-tab nzTitle="Excused">
                  <div *ngFor="let event of rejectedEvents">

                    <div
                      class="flex border-[1px] border-solid border-[#F0F0F0] rounded-lg p-5 justify-between xl:items-center gap-5 relative flex-col xl:flex-row"
                      *ngIf="event.eventType === 'Invite Only'" style="margin-bottom: 1rem"
                    >
                      <p
                        class="top-7 left-7 absolute font-[500] text-[13px] !text-[#fff] bg-[#28C5C0] rounded-full px-2 z-10"
                      >
                        {{ event.eventType }}
                      </p>
                      <div class="basis-[40%] h-[150px] xl:h-[300px] w-full">
                        <img
                          class="w-full rounded-lg h-full object-cover"
                          alt="image"
                          (error)="onImageError($event)"
                          [src]="event.thumbnail?.url || ''"
                        />
                      </div>
                      <div class="basis-[60%] w-full">
                        <h4
                          class="text-[#2F5EA4]  xsm:!text-md clickable-text"
                          (click)="viewEvent(this.event.id)"
                        >
                          {{ event.name }}
                        </h4>
                        <div class="my-3">
                          <p class="flex justify-start gap-2 items-center mb-0">
                            <svg
                              width="12"
                              height="15"
                              viewBox="0 0 12 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.738 12.1832L7.16878 11.6949L7.738 12.1832ZM4.262 12.1832L3.69279 12.6716L4.262 12.1832ZM6 13.5V12.75V13.5ZM10.25 6.41797C10.25 7.01125 9.89933 7.87637 9.27258 8.88918C8.66644 9.8687 7.87869 10.8674 7.16878 11.6949L8.30721 12.6716C9.0409 11.8164 9.88415 10.7514 10.5481 9.6785C11.1915 8.63885 11.75 7.46268 11.75 6.41797H10.25ZM4.83122 11.6949C4.12131 10.8674 3.33356 9.8687 2.72742 8.88918C2.10067 7.87637 1.75 7.01125 1.75 6.41797H0.25C0.25 7.46268 0.808534 8.63885 1.45189 9.6785C2.11585 10.7514 2.9591 11.8164 3.69279 12.6716L4.83122 11.6949ZM1.75 6.41797C1.75 4.12771 3.64105 2.25 6 2.25V0.75C2.83611 0.75 0.25 3.27599 0.25 6.41797H1.75ZM6 2.25C8.35895 2.25 10.25 4.12771 10.25 6.41797H11.75C11.75 3.27599 9.16389 0.75 6 0.75V2.25ZM7.16878 11.6949C6.77522 12.1536 6.53959 12.4244 6.33556 12.5938C6.16603 12.7345 6.08353 12.75 6 12.75V14.25C6.52474 14.25 6.93467 14.046 7.29377 13.7478C7.61838 13.4783 7.94762 13.0907 8.30721 12.6716L7.16878 11.6949ZM3.69279 12.6716C4.05238 13.0907 4.38161 13.4783 4.70623 13.7478C5.06533 14.046 5.47526 14.25 6 14.25V12.75C5.91647 12.75 5.83397 12.7345 5.66444 12.5938C5.46041 12.4244 5.22478 12.1536 4.83122 11.6949L3.69279 12.6716ZM3.375 6.64152C3.375 8.06428 4.61512 9.10536 6 9.10536V7.60536C5.31381 7.60536 4.875 7.11181 4.875 6.64152H3.375ZM6 9.10536C7.38488 9.10536 8.625 8.06428 8.625 6.64152H7.125C7.125 7.11181 6.68619 7.60536 6 7.60536V9.10536ZM8.625 6.64152C8.625 5.21876 7.38488 4.17768 6 4.17768V5.67768C6.68619 5.67768 7.125 6.17122 7.125 6.64152H8.625ZM6 4.17768C4.61512 4.17768 3.375 5.21876 3.375 6.64152H4.875C4.875 6.17122 5.31381 5.67768 6 5.67768V4.17768Z"
                                fill="#2D264B"
                                fill-opacity="0.25"
                              />
                            </svg>
                            <span class="font-semibold text-[13px]">{{
                              event.venue
                            }}</span>
                          </p>
                          <p class="flex justify-start gap-2 items-center">
                            <svg
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.25955 12.9271L2.69509 12.3165L2.25955 12.9271ZM1.58356 12.2634L2.18644 11.8172L1.58356 12.2634ZM11.4164 12.2634L10.8136 11.8172L11.4164 12.2634ZM10.7405 12.9271L11.176 13.5376L10.7405 12.9271ZM10.7405 3.27295L11.176 2.66237L10.7405 3.27295ZM11.4164 3.93664L10.8136 4.38278L11.4164 3.93664ZM2.25955 3.27295L2.69509 3.88352L2.69509 3.88352L2.25955 3.27295ZM1.58356 3.93664L2.18644 4.38278V4.38278L1.58356 3.93664ZM10.9109 9.93694L10.7957 9.19584L10.9109 9.93694ZM8.37095 12.4307L7.63052 12.3113L8.37095 12.4307ZM4.66667 7.95C4.25245 7.95 3.91667 8.28579 3.91667 8.7C3.91667 9.11421 4.25245 9.45 4.66667 9.45V7.95ZM8.33333 9.45C8.74755 9.45 9.08333 9.11421 9.08333 8.7C9.08333 8.28579 8.74755 7.95 8.33333 7.95V9.45ZM7.58333 3.3C7.58333 3.71421 7.91912 4.05 8.33333 4.05C8.74755 4.05 9.08333 3.71421 9.08333 3.3H7.58333ZM9.08333 1.5C9.08333 1.08579 8.74755 0.75 8.33333 0.75C7.91912 0.75 7.58333 1.08579 7.58333 1.5H9.08333ZM3.91667 3.3C3.91667 3.71421 4.25245 4.05 4.66667 4.05C5.08088 4.05 5.41667 3.71421 5.41667 3.3H3.91667ZM5.41667 1.5C5.41667 1.08579 5.08088 0.75 4.66667 0.75C4.25245 0.75 3.91667 1.08579 3.91667 1.5H5.41667ZM11.9823 9.9L12.7319 9.92616L11.9823 9.9ZM1.01768 6.3L0.268135 6.27384L1.01768 6.3ZM11.9823 6.3L12.7319 6.27384L11.9823 6.3ZM6.5 12.75C5.33784 12.75 4.52538 12.749 3.90099 12.6826C3.28984 12.6176 2.94812 12.497 2.69509 12.3165L1.824 13.5376C2.37417 13.9301 3.00692 14.0959 3.74233 14.1742C4.46449 14.251 5.37066 14.25 6.5 14.25V12.75ZM0.25 8.1C0.25 9.20791 0.248933 10.1002 0.32747 10.8119C0.407648 11.5385 0.578122 12.1655 0.980677 12.7095L2.18644 11.8172C2.00544 11.5726 1.88413 11.2429 1.81842 10.6474C1.75107 10.037 1.75 9.24193 1.75 8.1H0.25ZM2.69509 12.3165C2.49938 12.1769 2.32783 12.0083 2.18644 11.8172L0.980677 12.7095C1.21622 13.0278 1.50091 13.3072 1.824 13.5376L2.69509 12.3165ZM10.8136 11.8172C10.6722 12.0083 10.5006 12.1769 10.3049 12.3165L11.176 13.5376C11.4991 13.3072 11.7838 13.0278 12.0193 12.7095L10.8136 11.8172ZM10.3049 3.88352C10.5006 4.02313 10.6722 4.19171 10.8136 4.38278L12.0193 3.49051C11.7838 3.17221 11.4991 2.89284 11.176 2.66237L10.3049 3.88352ZM1.824 2.66237C1.50091 2.89285 1.21622 3.17221 0.980677 3.49051L2.18644 4.38278C2.32783 4.19171 2.49938 4.02313 2.69509 3.88352L1.824 2.66237ZM10.7957 9.19584C9.17493 9.44787 7.89059 10.6991 7.63052 12.3113L9.11138 12.5501C9.26547 11.5949 10.032 10.8326 11.0261 10.678L10.7957 9.19584ZM4.66667 9.45H8.33333V7.95H4.66667V9.45ZM11.9823 9.15C11.4534 9.15 11.1022 9.14818 10.7957 9.19584L11.0261 10.678C11.1897 10.6526 11.3994 10.65 11.9823 10.65L11.9823 9.15ZM11.25 8.1C11.25 8.80558 11.2499 9.3831 11.2328 9.87384L12.7319 9.92616C12.7501 9.40368 12.75 8.79713 12.75 8.1H11.25ZM11.2328 9.87384C11.1941 10.982 11.067 11.4747 10.8136 11.8172L12.0193 12.7095C12.5691 11.9665 12.6925 11.055 12.7319 9.92616L11.2328 9.87384ZM9.08333 13.4826C9.08334 12.9088 9.0861 12.7069 9.11138 12.5501L7.63052 12.3113C7.58136 12.6161 7.58334 12.9648 7.58333 13.4826L9.08333 13.4826ZM6.5 14.25C7.21027 14.25 7.82726 14.2501 8.35855 14.2322L8.30812 12.7331C7.80743 12.7499 7.21842 12.75 6.5 12.75V14.25ZM8.35855 14.2322C9.50599 14.1936 10.4253 14.0731 11.176 13.5376L10.3049 12.3165C9.94993 12.5697 9.43912 12.695 8.30812 12.7331L8.35855 14.2322ZM1.75 8.1C1.75 7.39442 1.7501 6.8169 1.76722 6.32616L0.268135 6.27384C0.249903 6.79632 0.25 7.40287 0.25 8.1H1.75ZM1.76722 6.32616C1.80589 5.218 1.93296 4.72532 2.18644 4.38278L0.980677 3.49051C0.430874 4.23349 0.307527 5.14498 0.268135 6.27384L1.76722 6.32616ZM1.01768 7.05H11.9823V5.55H1.01768V7.05ZM12.75 8.1C12.75 7.40287 12.7501 6.79632 12.7319 6.27384L11.2328 6.32616C11.2499 6.8169 11.25 7.39442 11.25 8.1H12.75ZM12.7319 6.27384C12.6925 5.14498 12.5691 4.23349 12.0193 3.49051L10.8136 4.38278C11.067 4.72532 11.1941 5.218 11.2328 6.32616L12.7319 6.27384ZM9.08333 3.3V2.71736H7.58333V3.3H9.08333ZM9.08333 2.71736V1.5H7.58333V2.71736H9.08333ZM6.5 3.45C7.21842 3.45 7.80743 3.45009 8.30812 3.46693L8.35855 1.96778C7.82726 1.94991 7.21027 1.95 6.5 1.95V3.45ZM8.30812 3.46693C9.43912 3.50498 9.94993 3.63031 10.3049 3.88352L11.176 2.66237C10.4253 2.12691 9.50599 2.00638 8.35855 1.96778L8.30812 3.46693ZM5.41667 3.3V2.71736H3.91667V3.3H5.41667ZM5.41667 2.71736V1.5H3.91667V2.71736H5.41667ZM6.5 1.95C5.78973 1.95 5.17274 1.94991 4.64145 1.96778L4.69188 3.46693C5.19257 3.45009 5.78158 3.45 6.5 3.45V1.95ZM4.64145 1.96778C3.49401 2.00638 2.57465 2.12691 1.824 2.66237L2.69509 3.88352C3.05007 3.63031 3.56088 3.50498 4.69188 3.46693L4.64145 1.96778Z"
                                fill="#2D264B"
                                fill-opacity="0.25"
                              />
                            </svg>
                            <span class="font-semibold text-[13px]">{{
                              this.formatDate(event.startTime)
                            }}</span>
                          </p>
                        </div>
                        <p
                          class="mt-3 text-[#706D6D] font-[400]"
                          *ngIf="
                            event.description && event.description.length > 250
                          "
                        >
                          {{ event.description.substring(0, 250) }} ...
                        </p>
                        <p
                          class="mt-3 text-[#706D6D] font-[400]"
                          *ngIf="
                            event.description && event.description.length < 250
                          "
                        >
                          {{ event.description }}
                        </p>
                      </div>
                    </div>
                  </div>
                </nz-tab>
              </nz-tabset>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </nz-card>
</div>
